(function () {
  function buildTabNav(root) {
    var nav = root.querySelector('[data-fp-nested-tabs-nav]');
    if (!nav) return;

    nav.innerHTML = '';

    root.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
      var inputId = panel.dataset.tabInputId;
      var title = panel.dataset.tabTitle;
      if (!inputId || !title) return;

      var li = document.createElement('li');
      var label = document.createElement('label');
      label.htmlFor = inputId;
      label.className = 'fpt__tab-item-label fp-nested-tabs__tab-label';
      label.textContent = title;
      li.appendChild(label);
      nav.appendChild(li);
    });
  }

  function refreshTabSwipers(root) {
    root.querySelectorAll('.fp-nested-tabs__swiper').forEach(function (container) {
      if (container.swiper) {
        container.swiper.update();
      }
    });
  }

  function bindTabChange(root) {
    var sectionId = root.dataset.sectionId;
    if (!sectionId || root.dataset.tabChangeBound === 'true') return;
    root.dataset.tabChangeBound = 'true';

    root.querySelectorAll('input[name="fp-tab-input-' + sectionId + '"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        window.requestAnimationFrame(function () {
          refreshTabSwipers(root);
          window.dispatchEvent(new Event('fp-nested-tabs:tab-change'));
        });
      });
    });
  }

  function initFpNestedTabs(root) {
    buildTabNav(root);
    bindTabChange(root);
  }

  function initAll() {
    document.querySelectorAll('[data-fp-nested-tabs]').forEach(initFpNestedTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-fp-nested-tabs]');
    if (root) initFpNestedTabs(root);
  });

})();
